import {Space, Tag} from 'antd'
import React, {useEffect, useState} from 'react'
import PageBuilder from '../../../components/panel/PageBuilder'
import {
    DealerProductFilter,
    useGetDealerArchivedProductsQuery,
    useGetDealerProductTagsQuery
} from '../../../api/dealerCatalogApi'
import ExtendedTable from "../../../components/ExtendedTable";
import {useFilterTable} from "../../../hooks/useFilterTable";

const DealerProductsArchived = () => {
    const {data: productTags} = useGetDealerProductTagsQuery(null)

    const [filter, setFilter] = useState<DealerProductFilter>({
        page: 1,
        name: '',
        name_sort: '',
        tags: [],

        date_created_range_start: '',
        date_created_range_end: '',
        date_range_created_sort: '',

        date_updated_range_start: '',
        date_updated_range_end: '',
        date_range_updated_sort: '',
    })

    const {data, isLoading, refetch} = useGetDealerArchivedProductsQuery(filter);

    const [
        filterByText,
        filterByData,
        filterBySelect,
    ] = useFilterTable<DealerProductFilter>(filter, setFilter);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            ...filterByText('name', "name_sort")
        },
        {
            title: "Date created",
            dataIndex: "date_created",
            ...filterByData("date_created_range_start", "date_created_range_end", "date_range_created_sort"),
        },
        {
            title: "Date updated",
            dataIndex: "date_updated",
            ...filterByData("date_updated_range_start", "date_updated_range_end", "date_range_updated_sort"),
        },
        {
            title: "Tags",
            dataIndex: "tags",
            ...filterBySelect("tags", productTags!, 'name'),
            render: (tags: string[]) => <Space size={[0, 'small']} wrap>
                {
                    tags.map(tag => (
                        <Tag key={tag} color="processing">{tag}</Tag>
                    ))
                }
            </Space>
        },
    ]

    useEffect(() => {
        refetch()
    }, [filter])

    return (
        <PageBuilder title="Archived Products" documentTitle="Archived Products">
            <ExtendedTable
                data={data}
                isLoading={isLoading}
                dataKey="products"
                columns={columns}
                onChange={(e) => setFilter(prevState => ({...prevState, page: e}))}
            />
        </PageBuilder>
    )
}

export default DealerProductsArchived
